import { useCallback } from 'react';
import { useHeaderResizeListener } from 'src/commons/utils/hooks';

export default (isMobile = false): void => {
  const callback = useCallback(
    (e: Event) => {
      const container: HTMLDivElement = (
        isMobile
          ? document.getElementsByTagName('ax-chrome-global-header')[0]
          : document.getElementById('sc-content-container')
      ) as HTMLDivElement;
      const customEvent: CustomEvent = e as CustomEvent;
      if (container && customEvent.detail.headerHeight) {
        container.style.marginTop = `${customEvent.detail.headerHeight}px`;
      }
    },
    [isMobile],
  );

  useHeaderResizeListener({ callback });
};
